export default __webpack_public_path__ + "static/media/soleado.b0f0afae.gif";